import Home from "./Home"
import ClientLogs from "./ClientLogs"

export { ClientLogs }
export default Home
